// extracted by mini-css-extract-plugin
export default {"rocket":"Rocket_rocket__eFh2s"};